import React from 'react';
import './SearchResult.css';
import defaultUserProfile from '../../assets/defaultUserProfile.jpeg';
import { Link } from 'react-router-dom';

const SearchResult = ({ result }) => {

  return (
    <div className='search-result'

    // onClick={(e) => alert(`You clicked on ${result}`)}
    >

      <div className='topProfileRight' style={{ width: '100%' }}>
          <div className='leftRightProfile'>

                <Link to={`/profile/${result?.hashed_id}/${result?.username}`} className='imgDIvRightSide'>

                    <img className='imgDIvRightSideProfile' src={ result &&
                            result.avatar != null
                              ? `https://dashboard.tiktaka.com/${result.avatar}`
                              : defaultUserProfile
                          } alt='none' />
                </Link>
                </div>
         <div className='userNameBlock' style={{ width: '65%' }}>

                        <div className='userNameRightSide'>{result ? result.name :'guest'}</div>
                        <div className='userFullName'>{result ? result.username :'username'}</div>
          </div>


  
        </div>

    

      {/* {result.name} */}

      </div>
  );
};

export default SearchResult;
